import React, { useState, useEffect } from 'react';
import axios from 'cccisd-axios';
import IconWarn from 'cccisd-icons/warning2';
import Loader from 'cccisd-loader';
import style from './style.css';

const Boilerplate = window.cccisd.boilerplate;
const Fortress = window.cccisd.fortress;

const CvLogin = () => {
    const [data, setData] = useState(null);
    const [redirectCountdown, setRedirectCountdown] = useState(10);

    useEffect(() => {
        async function getData() {
            // uses browser cookie to pass access_token along to backend api route
            const resp = await axios.post(Boilerplate.route('app.cvlogin'));
            setData(resp.data);
        }

        getData();
    }, []);

    useEffect(() => {
        if (data?.data?.redirectTo && !data?.data?.redirectNow) {
            setInterval(() => {
                setRedirectCountdown(p => p - 1);
            }, 1000);
        }
    }, [data]);

    const redirectTo = data?.data?.redirectTo;
    if (redirectTo && (redirectCountdown <= 0 || data?.data?.redirectNow)) {
        window.location = redirectTo;
        return <span />;
    }

    if (data?.status === 'error') {
        let errMessage = 'Could not log in at this time.';
        try {
            errMessage = Object.values(data.errors)[0][0];
        } catch (e) {
            // meh use default message
        }

        return (
            <div className="alert alert-warning">
                <p className="mb-0 d-flex align-items-center">
                    <span className="fs-1">
                        <IconWarn spaceRight />
                    </span>
                    {errMessage}
                </p>
                {redirectTo && (
                    <h2 className="mt-5">
                        Redirecting to&nbsp;
                        <a href={redirectTo} className="text-decoration-underline">
                            {redirectTo}
                        </a>
                        &nbsp; in {redirectCountdown} seconds...
                    </h2>
                )}
            </div>
        );
    }

    if (data?.status === 'success') {
        window.location = Boilerplate.url(Fortress.settings.config.after_login_url);
    }

    return (
        <div className={style.cvLogin}>
            <Loader loading type="inline" />
            <h4 className="mb-0 ms-2 d-inline">Loading...</h4>
        </div>
    );
};

export default CvLogin;
